module.exports = __webpack_public_path__ + "static/18-1-d55eeaddf9803b105bd0b1b9021e5306.jpg";